module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "food-diary"
    }
  }, [_c('mu-paper', {
    staticClass: "foodbar"
  }, [_c('mu-content-block', {
    staticClass: "foodBar inner"
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "30",
      "width": "25",
      "tablet": "30",
      "align": "right"
    }
  }, [_c('mu-flexbox', [_c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-icon-button', {
    attrs: {
      "icon": "chevron_left"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.subtractDay()
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('mu-col', {
    staticStyle: {
      "flex": "auto"
    },
    attrs: {
      "width": "50",
      "align": "center"
    }
  }, [_c('mu-flexbox', {
    staticStyle: {
      "height": "46px"
    },
    attrs: {
      "align": "center center",
      "justify": "center center"
    }
  }, [_c('mu-flexbox-item', {
    ref: "datepicker",
    staticClass: "c-datepicker-btn mediumTitle",
    attrs: {
      "align": "center",
      "grow": ""
    }
  }, [_c('mu-flexbox', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "justify": "center center",
      "align": "center",
      "wrap": "disallow"
    }
  }, [_c('mu-flexbox-item', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('mu-date-picker', {
    staticClass: "hiddenPicker",
    attrs: {
      "inputClass": "datePicker",
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "dateTimeFormat": _vm.dateFormat,
      "format": "DD-MM-YYYY",
      "fullWidth": ""
    },
    model: {
      value: (_vm.currentDate.ddmmyy),
      callback: function($$v) {
        _vm.$set(_vm.currentDate, "ddmmyy", $$v)
      },
      expression: "currentDate.ddmmyy"
    }
  }), _vm._v(" "), _c('span', [_c('mu-icon', {
    staticStyle: {
      "position": "relative",
      "top": "4px"
    },
    attrs: {
      "value": "date_range"
    }
  }), _vm._v("\n                    " + _vm._s(_vm.currentDate.presentational) + "\n                  ")], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "30",
      "width": "25",
      "tablet": "30",
      "align": "left"
    }
  }, [_c('mu-flexbox', [_c('mu-flexbox-item', [_c('mu-icon-button', {
    attrs: {
      "icon": "chevron_right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addDay()
      }
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('mu-paper', {
    staticClass: "foodbar",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "controls"
    }
  }, [_c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', [_c('mu-raised-button', {
    attrs: {
      "fullWidth": "",
      "label": "Add food"
    }
  })], 1), _vm._v(" "), (!_vm.isToday(_vm.currentDate.actual)) ? _c('mu-flexbox-item', {
    attrs: {
      "align": "left"
    }
  }, [_c('mu-raised-button', {
    attrs: {
      "fullWidth": "",
      "secondary": "",
      "label": _vm.$t('message.labelToday')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setToday()
      }
    }
  })], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('mu-paper', {
    staticClass: "intakebar desktop bottom"
  }, [_c('mu-content-block', {
    staticClass: "content"
  }, [_c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('div', {
    staticClass: "mediumTitle progress-item",
    domProps: {
      "textContent": _vm._s(_vm.isToday(_vm.currentDate.actual) ? _vm.$t('message.foodDiaryIntakeBar') : _vm.$t('message.foodDiaryIntakeBarNotToday'))
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('message.foodDiaryTodayYouveHad')) + "\n          ")]), _vm._v(" "), _c('ProgressItem', {
    attrs: {
      "bar-mode": _vm.barMode,
      "color": "#4ed8da",
      "total": _vm.getNutrientDisplayValue(_vm.nutritionTargets.carbohydrate, 'carbohydrate'),
      "unit": this.nutritionUnit,
      "value": _vm.getNutrientDisplayValue(_vm.totals.all.carbohydrate, 'carbohydrate'),
      "label": "carbs"
    }
  }), _vm._v(" "), _c('ProgressItem', {
    attrs: {
      "bar-mode": _vm.barMode,
      "color": "#c04dd8",
      "total": _vm.getNutrientDisplayValue(_vm.nutritionTargets.fat, 'fat'),
      "unit": this.nutritionUnit,
      "value": _vm.getNutrientDisplayValue(_vm.totals.all.fat, 'fat'),
      "label": "fat"
    }
  }), _vm._v(" "), _c('ProgressItem', {
    attrs: {
      "bar-mode": _vm.barMode,
      "color": "#e06950",
      "total": _vm.getNutrientDisplayValue(_vm.nutritionTargets.protein, 'protein'),
      "unit": this.nutritionUnit,
      "value": _vm.getNutrientDisplayValue(_vm.totals.all.protein, 'protein'),
      "last": true,
      "label": "protein"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-flat-button', {
    attrs: {
      "id": 'editNutritionUnit',
      "labelClass": "grey",
      "iconClass": "grey",
      "label": "Configure Charts",
      "icon": "settings",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openDialog('editNutritionUnitDialog')
      }
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "id": 'setTargets',
      "labelClass": "grey",
      "iconClass": "grey",
      "label": _vm.$t('message.foodDiaryModifyTargets'),
      "icon": "edit",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openDialog('setTargetsDialog')
      }
    }
  })], 1)], 1), _vm._v(" "), _c('mu-col', {
    staticClass: "holdDoughnut",
    staticStyle: {
      "margin-top": "-8px"
    },
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50",
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "innerDoughnut",
    staticStyle: {
      "height": "201px"
    }
  }, [(_vm.barMode === 'indeterminate') ? _c('mu-flexbox', {
    staticStyle: {
      "height": "100%",
      "margin-top": "16px"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 156
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.barMode === 'indeterminate') ? _c('mu-row', {
    staticStyle: {
      "width": "100%",
      "margin-top": "16px"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('mu-col', {
    attrs: {
      "align": "center",
      "width": "100",
      "desktop": "100",
      "tablet": "100"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('message.loadingText')) + "\n              ")])], 1) : _vm._e(), _vm._v(" "), (_vm.barMode !== 'indeterminate' && _vm.totals.all.calories === 0) ? _c('food-pie-empty', {
    staticClass: "foodPie"
  }) : _vm._e(), _vm._v(" "), (_vm.barMode !== 'indeterminate' && _vm.totals.all.calories > 0) ? _c('food-pie', {
    staticClass: "foodPie",
    attrs: {
      "fat": _vm.getNutrientDisplayValue(_vm.totals.all.fat, 'fat'),
      "carbs": _vm.getNutrientDisplayValue(_vm.totals.all.carbohydrate, 'carbohydrate'),
      "protein": _vm.getNutrientDisplayValue(_vm.totals.all.protein, 'protein'),
      "calories": _vm.totals.all.calories
    }
  }) : _vm._e(), _vm._v(" "), (_vm.barMode !== 'indeterminate') ? _c('mu-row', {
    staticStyle: {
      "width": "100%",
      "margin-top": "16px"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "33",
      "desktop": "33",
      "tablet": "33"
    }
  }, [_c('span', {
    staticClass: "mediumTitle"
  }, [_c('mu-badge', {
    attrs: {
      "color": "#4ed8da !important",
      "badgeClass": "smallBadge",
      "content": "",
      "circle": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getNutrientDisplayValue(_vm.totals.all.carbohydrate, 'carbohydrate', true)))])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "grey",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.nutrientCarbohydrateShort'))
    }
  })]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "33",
      "desktop": "33",
      "tablet": "33"
    }
  }, [_c('span', {
    staticClass: "mediumTitle"
  }, [_c('mu-badge', {
    attrs: {
      "color": "#c04dd8 !important",
      "badgeClass": "smallBadge",
      "content": "",
      "circle": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getNutrientDisplayValue(_vm.totals.all.fat, 'fat', true)))])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "grey",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.nutrientFat'))
    }
  }, [_vm._v("Fat")])]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "33",
      "desktop": "33",
      "tablet": "33"
    }
  }, [_c('span', {
    staticClass: "mediumTitle"
  }, [_c('mu-badge', {
    attrs: {
      "color": "#e06950 !important",
      "badgeClass": "smallBadge",
      "content": "",
      "circle": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getNutrientDisplayValue(_vm.totals.all.protein, 'protein', true)))])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "grey",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.nutrientProtein'))
    }
  })])], 1) : _vm._e()], 1)])], 1)], 1)], 1), _vm._v(" "), _c('mu-paper', {
    staticClass: "intakebar mobile bottom",
    staticStyle: {
      "padding": "24px"
    }
  }, [_c('mu-content-block', [_c('md-boards', {
    attrs: {
      "md-auto": false,
      "md-swipeable": true
    }
  }, [_c('md-board', [_c('div', [(_vm.barMode === 'indeterminate') ? _c('mu-flexbox', {
    staticStyle: {
      "height": "100%",
      "margin-top": "16px"
    }
  }, [_c('mu-flexbox-item', {
    staticStyle: {
      "height": "148px"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 74
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n                " + _vm._s(_vm.$t('message.loadingText')) + "\n              ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.barMode !== 'indeterminate') ? _c('div', {
    staticStyle: {
      "height": "148px"
    }
  }, [(_vm.totals.all.calories === 0) ? _c('food-pie-empty', {
    staticStyle: {
      "height": "148px"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.totals.all.calories > 0) ? _c('food-pie', {
    staticStyle: {
      "height": "148px"
    },
    attrs: {
      "fat": _vm.getNutrientDisplayValue(_vm.totals.all.fat, 'fat'),
      "carbs": _vm.getNutrientDisplayValue(_vm.totals.all.carbohydrate, 'carbohydrate'),
      "protein": _vm.getNutrientDisplayValue(_vm.totals.all.protein, 'protein'),
      "calories": _vm.totals.all.calories
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.barMode !== 'indeterminate') ? _c('mu-row', {
    staticStyle: {
      "width": "100%",
      "margin-top": "16px"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "33",
      "desktop": "33",
      "tablet": "33"
    }
  }, [_c('span', {
    staticClass: "mediumTitle"
  }, [_c('mu-badge', {
    attrs: {
      "color": "#4ed8da !important",
      "badgeClass": "smallBadge",
      "content": "",
      "circle": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getNutrientDisplayValue(_vm.totals.all.carbohydrate, 'carbohydrate', true)))])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "grey",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.nutrientCarbohydrateShort'))
    }
  })]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "33",
      "desktop": "33",
      "tablet": "33"
    }
  }, [_c('span', {
    staticClass: "mediumTitle"
  }, [_c('mu-badge', {
    attrs: {
      "color": "#c04dd8 !important",
      "badgeClass": "smallBadge",
      "content": "",
      "circle": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getNutrientDisplayValue(_vm.totals.all.fat, 'fat', true)))])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "grey",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.nutrientFat'))
    }
  }, [_vm._v("Fat")])]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "33",
      "desktop": "33",
      "tablet": "33"
    }
  }, [_c('span', {
    staticClass: "mediumTitle"
  }, [_c('mu-badge', {
    attrs: {
      "color": "#e06950 !important",
      "badgeClass": "smallBadge",
      "content": "",
      "circle": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getNutrientDisplayValue(_vm.totals.all.protein, 'protein', true)))])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "grey",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.nutrientProtein'))
    }
  })])], 1) : _vm._e()], 1)]), _vm._v(" "), _c('md-board', [_c('div', {
    staticClass: "mediumTitle progress-item",
    domProps: {
      "textContent": _vm._s(_vm.isToday(_vm.currentDate.actual) ? _vm.$t('message.foodDiaryIntakeBar') : _vm.$t('message.foodDiaryIntakeBarNotToday'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "progress-item"
  }, [_c('label', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.nutrientCarbohydrateShort'))
    }
  }), _vm._v(":\n              " + _vm._s(_vm.getNutrientDisplayValue(_vm.totals.all.carbohydrate, 'carbohydrate', true)))]), _vm._v(" "), _c('mu-linear-progress', {
    attrs: {
      "color": _vm.barMode === 'indeterminate' ? 'rgba(78, 216, 218, 0.24)' : '#4ed8da',
      "size": 16,
      "mode": _vm.barMode,
      "value": (_vm.totals.all.carbohydrate) ? (_vm.totals.all.carbohydrate / _vm.nutritionTargets.carbohydrate * 100) : 0
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "progress-item"
  }, [_c('label', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.nutrientFat'))
    }
  }), _vm._v(":\n              " + _vm._s(_vm.getNutrientDisplayValue(_vm.totals.all.fat, 'fat', true)))]), _vm._v(" "), _c('mu-linear-progress', {
    attrs: {
      "color": _vm.barMode === 'indeterminate' ? 'rgba(192, 77, 216, 0.24)' : '#c04dd8',
      "size": 16,
      "mode": _vm.barMode,
      "value": (_vm.totals.all.fat) ? (_vm.totals.all.fat / _vm.nutritionTargets.fat * 100) : 0
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "progress-item last"
  }, [_c('label', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.nutrientProtein'))
    }
  }), _vm._v(":\n              " + _vm._s(_vm.getNutrientDisplayValue(_vm.totals.all.protein, 'protein', true)))]), _vm._v(" "), _c('mu-linear-progress', {
    attrs: {
      "color": _vm.barMode === 'indeterminate' ? 'rgba(224, 105, 80, 0.24)' : '#e06950',
      "size": 16,
      "mode": _vm.barMode,
      "value": (_vm.totals.all.protein) ? (_vm.totals.all.protein / _vm.nutritionTargets.protein * 100) : 0
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-flat-button', {
    attrs: {
      "id": 'editNutritionUnit',
      "labelClass": "grey",
      "iconClass": "grey",
      "label": "Configure Charts",
      "icon": "settings",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openDialog('editNutritionUnitDialog')
      }
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "id": 'setTargets',
      "labelClass": "grey",
      "iconClass": "grey",
      "label": _vm.$t('message.foodDiaryModifyTargets'),
      "icon": "edit",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openDialog('setTargetsDialog')
      }
    }
  })], 1)])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "content bottom"
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "50",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-raised-button', {
    staticStyle: {
      "height": "54px",
      "color": "#0179d5"
    },
    attrs: {
      "icon": "equalizer",
      "label": _vm.$t('message.labelViewHistory'),
      "fullWidth": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goTo('FoodDiaryHistory')
      }
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "50",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-raised-button', {
    staticStyle: {
      "height": "54px",
      "color": "#0179d5"
    },
    attrs: {
      "icon": "file_download",
      "label": _vm.$t('message.exportTextData'),
      "fullWidth": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openDialog('exportDataDialog')
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-dialog', {
    ref: "setTargetsDialog"
  }, [_c('mu-card-header', {
    attrs: {
      "title": _vm.$t('message.foodDiaryNutritionPanelHeaderText'),
      "subTitle": _vm.$t('message.foodDiaryNutritionPanelSubHeaderText'),
      "titleClass": "blueTitle largeTitle"
    }
  }), _vm._v(" "), _c('mu-card-text', {
    staticStyle: {
      "overflow-x": "hidden",
      "overflow-y": "scroll",
      "-webkit-overflow-scrolling": "touch"
    }
  }, [_c('mu-select-field', {
    attrs: {
      "label": _vm.$t('message.labelNutrientTargetHelpText'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.preset),
      callback: function($$v) {
        _vm.preset = $$v
      },
      expression: "preset"
    }
  }, _vm._l((_vm.nutrientPresets), function(item, index) {
    return _c('mu-menu-item', {
      key: 'preset-' + index,
      attrs: {
        "title": item.name,
        "value": item
      }
    })
  }), 1), _vm._v(" "), _c('form', [_c('div', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.nutrientCarbohydrateShort'))
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#0179d5"
    },
    domProps: {
      "textContent": _vm._s(_vm.settingsModel.carbohydrate + 'g')
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    },
    domProps: {
      "textContent": _vm._s(300 + 'g')
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-slider', {
    staticClass: "carbohydrate-slider",
    attrs: {
      "step": 1,
      "max": 300
    },
    model: {
      value: (_vm.settingsModel.carbohydrate),
      callback: function($$v) {
        _vm.$set(_vm.settingsModel, "carbohydrate", _vm._n($$v))
      },
      expression: "settingsModel.carbohydrate"
    }
  })], 1), _vm._v(" "), _c('div', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.nutrientFat'))
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#ff895e"
    },
    domProps: {
      "textContent": _vm._s(_vm.settingsModel.fat + 'g')
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    },
    domProps: {
      "textContent": _vm._s(350 + 'g')
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-slider', {
    staticClass: "fat-slider",
    attrs: {
      "step": 1,
      "max": 350
    },
    model: {
      value: (_vm.settingsModel.fat),
      callback: function($$v) {
        _vm.$set(_vm.settingsModel, "fat", _vm._n($$v))
      },
      expression: "settingsModel.fat"
    }
  })], 1), _vm._v(" "), _c('div', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.nutrientProtein'))
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#ff5a5f"
    },
    domProps: {
      "textContent": _vm._s(_vm.settingsModel.protein + 'g')
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    },
    domProps: {
      "textContent": _vm._s(350 + 'g')
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-slider', {
    staticClass: "protein-slider",
    attrs: {
      "step": 1,
      "max": 350
    },
    model: {
      value: (_vm.settingsModel.protein),
      callback: function($$v) {
        _vm.$set(_vm.settingsModel, "protein", _vm._n($$v))
      },
      expression: "settingsModel.protein"
    }
  })], 1)])], 1), _vm._v(" "), _c('mu-card-actions', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-flat-button', {
    attrs: {
      "label": _vm.$t('message.cancelText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeDialog('setTargetsDialog')
      }
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "label": _vm.isSettingsUpdating ? _vm.$t('message.updatingText') : _vm.$t('message.updateText'),
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateTargets.apply(null, arguments)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('md-dialog', {
    ref: "exportDataDialog"
  }, [_c('mu-card-header', {
    attrs: {
      "title": _vm.$t('message.foodDiaryExportDataTitle'),
      "subTitle": _vm.$t('message.foodDiaryExportDataSubTitle')
    }
  }), _vm._v(" "), _c('mu-card-text', [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "label": _vm.$t('message.labelFromDate'),
      "dateTimeFormat": _vm.dateFormat,
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "format": "DD-MM-YYYY",
      "fullWidth": ""
    },
    model: {
      value: (_vm.exportDate.fromDate),
      callback: function($$v) {
        _vm.$set(_vm.exportDate, "fromDate", $$v)
      },
      expression: "exportDate.fromDate"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "label": _vm.$t('message.labelToDate'),
      "dateTimeFormat": _vm.dateFormat,
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "format": "DD-MM-YYYY",
      "fullWidth": ""
    },
    model: {
      value: (_vm.exportDate.toDate),
      callback: function($$v) {
        _vm.$set(_vm.exportDate, "toDate", $$v)
      },
      expression: "exportDate.toDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('mu-card-actions', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-flat-button', {
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeDialog('exportDataDialog')
      }
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "disabled": _vm.isExporting,
      "label": _vm.isExporting ? _vm.$t('message.exportingText') : _vm.$t('message.exportText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.exportData.apply(null, arguments)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('md-dialog', {
    ref: "addFoodDialog",
    staticClass: "food-dialog-container",
    on: {
      "close": _vm.onFoodDialogClose,
      "open": _vm.onFoodDialogOpen
    }
  }, [_c('div', {
    staticClass: "add-food-dialog",
    class: {
      extraHeight: _vm.activeDialogMethod === 'searchResult'
    }
  }, [(_vm.activeDialogMethod === null) ? _c('fd-landing-dialog', {
    attrs: {
      "title": _vm.activeMealType.panelTitle,
      "mealTypeId": _vm.activeMealType.mealTypeId,
      "date": _vm.currentDate.actual.format()
    },
    on: {
      "choseToSearchWith": _vm.searchMethod,
      "closeDialogAndReload": function($event) {
        return _vm.closeDialogAndReload('addFoodDialog')
      },
      "closeDialog": function($event) {
        return _vm.closeDialog('addFoodDialog')
      },
      "onRecentItemSelected": _vm.selectRecent
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeDialogMethod === 'autocomplete') ? _c('fd-autocomplete-dialog', {
    attrs: {
      "searchTerm": _vm.selectedSearchTerm,
      "title": _vm.activeMealType.panelTitle
    },
    on: {
      "closeDialog": function($event) {
        return _vm.closeDialog('addFoodDialog')
      },
      "foodNameSelected": _vm.foodNameSelected
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeDialogMethod === 'mymeals') ? _c('fd-mymeals-dialog', {
    attrs: {
      "mealTypeId": _vm.activeMealType.mealTypeId,
      "date": _vm.currentDate.actual.format(),
      "title": _vm.activeMealType.panelTitle
    },
    on: {
      "closeDialog": function($event) {
        return _vm.closeDialog('addFoodDialog')
      },
      "closeDialogAndReload": function($event) {
        return _vm.closeDialogAndReload('addFoodDialog')
      },
      "foodNameSelected": _vm.foodNameSelected
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeDialogMethod === 'searchResults') ? _c('fd-search-results-dialog', {
    attrs: {
      "title": _vm.activeMealType.panelTitle,
      "searchTerm": _vm.selectedSearchTerm
    },
    on: {
      "goBack": _vm.searchMethod,
      "foodSelected": _vm.foodSelected,
      "closeDialog": function($event) {
        return _vm.closeDialog('addFoodDialog')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeDialogMethod === 'searchResult' || _vm.activeDialogMethod === 'editResult') ? _c('fd-food-result-dialog', {
    attrs: {
      "inputDate": _vm.currentDate.ddmmyy,
      "title": _vm.activeMealType.panelTitle,
      "mealTypeId": _vm.activeMealType.mealTypeId,
      "foodId": _vm.foodResultId,
      "mode": _vm.foodResultMode
    },
    on: {
      "foodAdded": function($event) {
        return _vm.getData()
      },
      "goBack": _vm.searchMethod,
      "closeDialog": function($event) {
        return _vm.closeDialog('addFoodDialog')
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('md-dialog', {
    ref: "editFoodDialog",
    staticClass: "food-dialog-container",
    on: {
      "close": _vm.onEditDialogClose
    }
  }, [_c('mu-card', {
    staticClass: "add-food-dialog",
    class: {
      extraHeight: _vm.selectedFood.fs_food_id
    }
  }, [(_vm.selectedFood.fs_food_id) ? _c('fd-edit-food-dialog', {
    attrs: {
      "mealTypeId": 1,
      "foodObj": _vm.selectedFood
    },
    on: {
      "closeDialog": function($event) {
        return _vm.closeDialog('editFoodDialog')
      },
      "foodUpdated": function($event) {
        return _vm.getData()
      }
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('fd-meal-list', {
    staticClass: "bottom",
    attrs: {
      "totals": _vm.totals.breakfast,
      "foods": _vm.foods.breakfast,
      "recipes": _vm.recipes.breakfast,
      "mealTypeTitle": _vm.$t('message.foodDiaryBreakfast'),
      "mealType": "breakfast",
      "isLoading": _vm.isLoading
    },
    on: {
      "foodSelected": _vm.openEditPane,
      "removeFood": _vm.removeBreakfast,
      "removeRecipe": _vm.removeRecipe,
      "updateTotals": _vm.updateTotals,
      "reloadData": _vm.getData
    }
  }, [_c('mu-icon-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: (_vm.$t('message.addEntryText')),
      expression: "$t('message.addEntryText')",
      modifiers: {
        "top": true
      }
    }],
    attrs: {
      "slot": "button",
      "labelPosition": "before",
      "icon": "add_circle"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openDialog('addFoodDialog', {
          panelTitle: _vm.$t('message.foodDiaryAddingBreakfast'),
          mealType: 'breakfast',
          mealTypeId: 1
        })
      }
    },
    slot: "button"
  })], 1), _vm._v(" "), _c('fd-meal-list', {
    staticClass: "bottom",
    attrs: {
      "totals": _vm.totals.lunch,
      "foods": _vm.foods.lunch,
      "recipes": _vm.recipes.lunch,
      "mealTypeTitle": _vm.$t('message.foodDiaryLunch'),
      "mealType": "lunch",
      "isLoading": _vm.isLoading
    },
    on: {
      "foodSelected": _vm.openEditPane,
      "removeFood": _vm.removeLunch,
      "removeRecipe": _vm.removeRecipe,
      "updateTotals": _vm.updateTotals,
      "reloadData": _vm.getData
    }
  }, [_c('mu-icon-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: (_vm.$t('message.addEntryText')),
      expression: "$t('message.addEntryText')",
      modifiers: {
        "top": true
      }
    }],
    attrs: {
      "slot": "button",
      "labelPosition": "before",
      "icon": "add_circle"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openDialog('addFoodDialog', {
          panelTitle: _vm.$t('message.foodDiaryAddingLunch'),
          mealType: 'lunch',
          mealTypeId: 2
        })
      }
    },
    slot: "button"
  })], 1), _vm._v(" "), _c('fd-meal-list', {
    staticClass: "bottom",
    attrs: {
      "totals": _vm.totals.dinner,
      "foods": _vm.foods.dinner,
      "recipes": _vm.recipes.dinner,
      "mealTypeTitle": _vm.$t('message.foodDiaryDinner'),
      "mealType": "dinner",
      "isLoading": _vm.isLoading
    },
    on: {
      "foodSelected": _vm.openEditPane,
      "removeFood": _vm.removeDinner,
      "removeRecipe": _vm.removeRecipe,
      "updateTotals": _vm.updateTotals,
      "reloadData": _vm.getData
    }
  }, [_c('mu-icon-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: (_vm.$t('message.addEntryText')),
      expression: "$t('message.addEntryText')",
      modifiers: {
        "top": true
      }
    }],
    attrs: {
      "slot": "button",
      "labelPosition": "before",
      "icon": "add_circle"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openDialog('addFoodDialog', {
          panelTitle: _vm.$t('message.foodDiaryAddingDinner'),
          mealType: 'dinner',
          mealTypeId: 3
        })
      }
    },
    slot: "button"
  })], 1), _vm._v(" "), _c('fd-meal-list', {
    staticClass: "bottom",
    attrs: {
      "totals": _vm.totals.snack,
      "foods": _vm.foods.snack,
      "recipes": _vm.recipes.snack,
      "mealTypeTitle": _vm.$t('message.foodDiarySnack'),
      "mealType": "snack",
      "isLoading": _vm.isLoading
    },
    on: {
      "foodSelected": _vm.openEditPane,
      "removeFood": _vm.removeSnack,
      "removeRecipe": _vm.removeRecipe,
      "updateTotals": _vm.updateTotals,
      "reloadData": _vm.getData
    }
  }, [_c('mu-icon-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: (_vm.$t('message.addEntryText')),
      expression: "$t('message.addEntryText')",
      modifiers: {
        "top": true
      }
    }],
    attrs: {
      "slot": "button",
      "labelPosition": "before",
      "icon": "add_circle"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openDialog('addFoodDialog', {
          panelTitle: _vm.$t('message.foodDiaryAddingSnack'),
          mealType: 'snack',
          mealTypeId: 4
        })
      }
    },
    slot: "button"
  })], 1), _vm._v(" "), _c('NutritionUnitDialog', {
    ref: "editNutritionUnitDialog",
    attrs: {
      "initialUnit": _vm.nutritionUnit
    },
    on: {
      "nutritionUnitChanged": _vm.onNutritionUnitUpdate,
      "close": function($event) {
        return _vm.closeDialog('editNutritionUnitDialog')
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0cc97923","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/FoodDiary/FoodDiary.vue
// module id = 3596
// module chunks = 1